/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.209.1-v202610071147-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * The columns for this Stored Table
 */
export interface StoredTableColumnOutputV1 {
    /**
     * The stored table column's name
     */
    "columnName": string;
    /**
     * 1-based index representing the position of the column in the table
     */
    "columnOrder"?: number;
    /**
     * The type of the column being defined
     */
    "columnType": ColumnTypeEnum;
    /**
     * The stored table column's Unit of Measure
     */
    "columnUom"?: string;
    /**
     * The stored table column's optional description
     */
    "description"?: string;
    /**
     * The stored table column's ID
     */
    "id": string;
    /**
     * Whether the column is hidden
     */
    "isHidden": boolean;
    /**
     * Whether the column is indexed
     */
    "isIndexed": boolean;
    /**
     * Whether to sort ascending
     */
    "sortAscending": boolean;
    /**
     * The sort index for the column, null if not sorted
     */
    "sortIndex"?: number;
}

export const ColumnTypeEnum = {
    UUID: 'UUID',
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    TIMESTAMPTZ: 'TIMESTAMPTZ',
    BOOLEAN: 'BOOLEAN'
} as const;

export type ColumnTypeEnum = typeof ColumnTypeEnum[keyof typeof ColumnTypeEnum];
